const api = {
    xcxsctp: '/index/login/xcxsctp', //上传文件
    hqyzmkey: '/login/hqyzmkey', //获取图片验证码
    createtpyzm: '/login/createtpyzm', //获取图片验证码
    dologin: '/login/qyweblogin',  //后台登录 
    zuocedaohanglan: '/index/zuocedaohanglan',  //导航栏 
    addzsxiangmu: '/index/addzsxiangmu',  //添加项目 
    wendangxxlist: '/index/wendangxxlist',  //文件列表 
    delwendang: '/index/delwendang',  //文件删除
    editwendang: '/index/wendangbj/editwendang',  //编辑保存文件
    daochuwenjian: '/wendangbj/daochuwenjian',  //导出文件
    aichat: '/index/index/index2',  //ai流式输出接口
}


export default api